// The code provided is a TypeScript function component for React,named ConditionalWrapper.
// This component is designed to conditionally wrap its children with a provided wrapper component based on a boolean condition.
function ConditionalWrapper({ condition, wrapper, children, }) {
    return condition ? wrapper(children) : children;
}

export { ConditionalWrapper as default };
//# sourceMappingURL=ConditionalWrapper.js.map
